import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { getAccountListSelector, getMenuListSelector } from '../../store/selectors/app.selector'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import { REQUEST_MENUS } from '../Layout/menu-names'

export default function Requests() {
  const history = useHistory()
  const accounts = useSelector(getAccountListSelector) || []
  const { t } = useTranslation()
  const menuConfig = useSelector(getMenuListSelector)['REQUESTS'] || {}

  return (
    <LayoutWithAccountCard breadCumKey='REQUEST'>
      <Row>
        {Object.keys(menuConfig).length>0 && REQUEST_MENUS.map((option, index) => (
          <>
          {menuConfig[option.key] && (
          <Col
            xs={'auto'}
            sm={'auto'}
            md={'auto'}
            key={index}
            className='account-menu-card'
            onClick={() => (accounts.length > 0 ? history.push(option.link) : '')}>
            <img width={52} height={40} src={option.icon} />
            <h2>{t(option.title)}</h2>
            <span>{t(option.desc)}</span>
          </Col>
          )}
          </>
        ))}
      </Row>
    </LayoutWithAccountCard>
  )
}
